import React from "react";
import { statusMeta, CHANNEL_LABELS, REASON_LABELS, PRIORITY_META } from "./leadMeta";

export const StatusPill = ({ status, large }) => {
  const m = statusMeta(status);
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 5,
      padding: large ? "5px 14px" : "3px 10px", fontSize: large ? 12.5 : 11.5, fontWeight: 600,
      borderRadius: 20, whiteSpace: "nowrap", fontFamily: "'Inter', sans-serif",
      background: m.bg, border: `1px solid ${m.border}`, color: m.color,
    }}>
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: m.dot, flexShrink: 0 }} />
      {m.label}
    </span>
  );
};

// Booking channel (Web/App) — copied automatically from the linked booking,
// never picked by hand. Renders nothing for a lead with no channel (a
// walk-in lead with no linked booking to copy it from).
export const ChannelBadge = ({ channel }) => {
  if (!channel) return <span style={{ fontSize: 11.5, color: "#9CA3AF" }}>—</span>;
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 6,
      padding: "3px 9px", fontSize: 11.5, fontWeight: 500, borderRadius: 7, whiteSpace: "nowrap",
      background: "#F3F4F6", color: "#4B5563",
    }}>
      {CHANNEL_LABELS[channel] || channel}
    </span>
  );
};

// Why the lead exists (Payment Pending, Cart Abandoned, ...) — the old
// SOURCE_LABELS dropdown values, minus "Manual".
export const ReasonBadge = ({ reason }) => {
  if (!reason) return <span style={{ fontSize: 11.5, color: "#9CA3AF" }}>—</span>;
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 6,
      padding: "3px 9px", fontSize: 11.5, fontWeight: 500, borderRadius: 7, whiteSpace: "nowrap",
      background: "#F3F4F6", color: "#4B5563",
    }}>
      {REASON_LABELS[reason] || reason}
    </span>
  );
};

export const PriorityChip = ({ priority }) => {
  const m = PRIORITY_META[priority] || PRIORITY_META.Low;
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12.5, fontWeight: 600, fontFamily: "'Inter', sans-serif", color: m.color }}>
      <span style={{ width: 7, height: 7, borderRadius: 2, background: m.dot }} />
      {priority}
    </span>
  );
};
